export const USER_STATUSES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const USER_STATUS_VARIANTS = {
  Active: "success",
  Inactive: "default",
};

export const getUserStatus = ({ isActive }) =>
  isActive ? USER_STATUSES.ACTIVE : USER_STATUSES.INACTIVE;

export const defaultUser = {
  active: true,
  status: getUserStatus({ isActive: true }),
  userId: "",
  email: "",
  alternateEmail: "",
  name: "",
  organizationId: "",
  role: "",
  username: "",
  tableauConfig: { tableauLicense: "", tableauUser: false },
  direct_data_access_enabled: false,
};
